import { AppRouter } from "@/navigation/AppRouter";

function App() {
  return (
    <div className="w-screen h-screen overflow-hidden">
      <AppRouter />
    </div>
  );
}

export default App;
